import {
  initialState,
  Actions,
  State,
  GET_RESPONSIBLE_CUSTOMERS,
  GET_RESPONSIBLE_CUSTOMERS_SUCCESS,
  GET_RESPONSIBLE_CUSTOMERS_ERROR,
  RESET_GET_RESPONSIBLE_CUSTOMERS,
} from '../../types/responsible/get-customers'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_RESPONSIBLE_CUSTOMERS:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case GET_RESPONSIBLE_CUSTOMERS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case GET_RESPONSIBLE_CUSTOMERS_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_GET_RESPONSIBLE_CUSTOMERS:
      return initialState
    default:
      return state
  }
}

export default reducers
